import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import { LandCoverChangeChart } from '@/components/Charts/LandCoverChange';
import { GraphFact } from '@/components/Charts/types';
import { useMapRadiusContext } from '@/components/MapOverview/components/MapRadiusContextProvider';
import { isNullish } from '@/utils/booleans';

import { NoPlotData } from '../NoPlotData';

export const LandCoverChangeGraphTile = ({
  landCoverChange,
}: {
  landCoverChange: PlotReportFactElement<GraphFact[]>;
}) => {
  const { t } = useTranslation();
  const { radius } = useMapRadiusContext();

  const noChartData = isNullish(landCoverChange.value);

  if (noChartData) {
    return <NoPlotData />;
  }

  return (
    <Stack center data-testid='land-cover-graph-tile'>
      <Stack spacing={2.5} className='w-full items-center justify-center px-1 py-6 lg:items-start lg:p-8 lg:pl-1'>
        <ChartHeading
          heading={t('shared.ncaDetail.details.landCoverChange.labels.graphHeadline', {
            radius,
          })}
          className='w-full px-6 sm:px-0'
          popover={{
            title: t('shared.ncaDetail.details.landCoverChange.labels.graphHeadline', {
              radius,
            }),
            body: t('shared.ncaDetail.details.landCoverChange.labels.graphHeadlineTooltip'),
          }}
        />
        <LandCoverChangeChart data={landCoverChange} data-testid='land-cover-change-chart' />
      </Stack>
    </Stack>
  );
};
